import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '../../common/withRouter';
import { Link } from 'react-router';
import { MotifTabControl, MotifTabNavigation } from '@ey-xd/motif-react';
import * as authActions from '../../actions/authActions';

/**
 * AnalyticsContainer component for Analytics Reports section, managing both "View Report" and "Publish Data" tabs
 * @extends {React.Component}
 */
export class AnalyticsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // add additional local state here as needed
    };

    this.isAdminUser = this.isAdminUser.bind(this);
  }

  componentDidMount() {
    // load initial data here
  }

  componentWillUnmount() {
    // cleanup if needed
  }

  /**
   * Determines if the current user is a System Administrator or Engagement Administrator
   * @returns {boolean} True if user is an admin, otherwise false
   */
  isAdminUser() {
    const { currentUserAuthorizations, clientId } = this.props;

    if (!Array.isArray(currentUserAuthorizations)) {
      return false;
    }

    const isSysAdmin = authActions.isSystemAdministrator(
      currentUserAuthorizations
    );
    const isEngAdmin = authActions.isEngagementAdministrator(
      currentUserAuthorizations,
      clientId
    );

    return isSysAdmin || isEngAdmin;
  }

  render() {
    const isAdmin = this.isAdminUser();

    const tabs = [
      <Link
        key="viewReport"
        to={`/client/${this.props.clientId}/analytics/viewReport`}
        tabIndex="-1"
      >
        <MotifTabControl
          role="tab"
          aria-selected={false}
          data-testid="tbViewReport"
        >
          View Report
        </MotifTabControl>
      </Link>,
    ];

    if (isAdmin) {
      tabs.push(
        <Link
          key="managePublishedData"
          to={`/client/${this.props.clientId}/analytics/managePublishedData`}
          tabIndex="-1"
        >
          <MotifTabControl
            className="motif-active"
            role="tab"
            aria-selected={true}
            data-testid="tbManagePublishedData"
          >
            Manage Published Data
          </MotifTabControl>
        </Link>
      );
    }

    return (
      <React.Fragment>
        <h2 data-testid="pghdrAnalytics">Analytics Reports</h2>

        <MotifTabNavigation variant="default">{tabs}</MotifTabNavigation>
      </React.Fragment>
    );
  }
}

AnalyticsContainer.propTypes = {
  currentUserAuthorizations: PropTypes.array,
  clientId: PropTypes.number,
  router: PropTypes.object,
  // map additional prop types as needed
};

function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    currentUserAuthorizations: state.currentUserAuthorizations,
    clientId: cid,
    // map required pieces of state here
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // bind action creators here when needed
    // example: actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsContainer)
);
